var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoHistoriqueSansTexte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.888,
    height: 40.888,
    viewBox: "4.173 -1.500 40.888 40.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_historique",
    "data-name": "picto historique",
    transform: "translate(5.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M18.944,37.888A18.965,18.965,0,0,1,0,18.944a.5.5,0,0,1,1,0A17.944,17.944,0,1,0,18.944,1,17.75,17.75,0,0,0,7.732,4.934a.5.5,0,0,1-.625-.781A18.735,18.735,0,0,1,18.944,0a18.944,18.944,0,1,1,0,37.888",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M9.851,5.982,4.712,7.212l1.5-5.066Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_116",
    "data-name": "Trac\\xE9 116",
    d: "M25.844,26.948a.5.5,0,0,1-.229-.056l-8.667-4.48V11.439a.5.5,0,0,1,1,0V21.8L26.074,26a.5.5,0,0,1-.23.944",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoHistoriqueSansTexte);
export default __webpack_public_path__ + "static/media/picto_historique_sans_texte.90e990517671df77a1f31062cfcec556.svg";
export { ForwardRef as ReactComponent };